import { Box, Typography, Tab, Tabs, Card, CardContent, Modal, Grid, IconButton, Divider, Dialog, DialogContent,DialogActions, DialogTitle } from "@mui/material";
import React, { useEffect, useState } from "react";
import DefaultContainer from "../components/DefaultContainer";
import DefaultHeader from "../components/DefaultHeader";
import { getHistory } from "../services/Transactions";
import { getOngoingReservations, getFinishedReservations, cancelReservation } from "../services/Reservation";
import MoneyFormat from "../components/MoneyFormat";
import { useLocation, useNavigate } from "react-router-dom";
import ls, { off } from "local-storage";
import moment from "moment";
import Toast from "../components/Snackbar";
import 'moment/locale/id';
import { getByID } from "../services/Partners";
import {Button} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


export default function HistoryScreen() {
  const navigate = useNavigate();
  const location = useLocation()
  const [history, setHistory] = useState([]);
  const [ongoing, setOngoing] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = React.useState(0);
  const [reservationModal, setReservationModal] = useState(false);
  const [reservationDetails, setResevationDetails] = useState({})
   const [msg, setMsg] = useState("");
   const [status, setStatus] = useState(0);
   const [isOpen, setIsOpen] = useState(false);
   const [isDialogOpen, setIsDialogOpen] = useState(false)

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString)
  const partnerID = urlParams.get('partnerID')

  async function fetchPartnerDetail(id) {
    await getByID(id).then((response) => {
      if (response.partners.length > 0) {
        ls.set("sfPartner", response.partners[0]);
        ls.set("sfHours",response.openingHour[0]);
      }
      setLoading(false);
    });
  }

  useEffect(() => {

    if(ls.get("sfToken") === null 
    || ls.get("sfToken").includes("dC9lNEx5UHNmb2VIWURoMzQrZDNvQmRGMVVpK2FZSkpaVDlMNUljYjl6b242SWtZK1RVd29ST1J1aUdEZEl3VjA2VFFLdDMzWkc4dmtvcjVJYURz")
    || ls.get("sfToken").includes("V2tDRTRkTXRJajhMTllJajdOY3pucWlKQXBLV1l2RGR1UWtwL3IyZVd5d2FQSXR6a0NCZTl3dE1FN1p0ZDlZK2tuSlJ1Y0RsWHI1Q3VsNHFCdWZqTFZzVzN3ZWZHR2lNUUt3K05ka1hSQjU1a1FVTDArMW14MWFkS2pweDRJa2ExR001SzFZcFJoTjB6T1ZSR3M3ZEtBPT0=")
    ){
      ls.remove("redux_localstorage_simple")
      navigate("/auth", {
        replace: true,
        state: { to: "/history" },
      })
    } else {
      if(ls.get("redux_localstorage_simple")){
        fetchHistory();
        fetchOngoing()
        if(ls.get("sfPartner") === null){
          fetchPartnerDetail(ls.get("partnerID") ? ls.get("partnerID") : partnerID)
        }  
      }else{
        setHistory([])
        navigate(`/auth?partnerID=${partnerID}`, { state: { to: "/order", from:"/history" } });
      }
    }
  }, []);

  async function fetchHistory() {
    const partnerID = ls.get("sfPartner").id;
    setLoading(true);
    await getFinishedReservations(partnerID).then((response) => {
      setHistory(response["reservations"]);
      setLoading(false);
    });
  }

  async function fetchOngoing() {
    const partnerID = ls.get("sfPartner").id;
    setLoading(true);
    await getOngoingReservations(partnerID).then((response) => {
      setOngoing(response["reservations"]);
      setLoading(false);
    });
  }

  async function cancelReservationF(id) {
    let data = {
      id:id
    }
    // console.log(data);
    
    await cancelReservation(data).then((response)=>{
      if(response.success===1){
        setStatus(1)
        setMsg("Berhasil Membatalkan Reservasi")
        setTimeout(() => {
            setIsOpen(true);
        
            // Hide after 3 seconds (adjust timing as needed)
            setTimeout(() => {
              setIsOpen(false);
              navigate(0)
            }, 1000);
        
          }, 300);
      }else{
        setStatus(0)
        setMsg(response.msg)
        setTimeout(() => {
            setIsOpen(true);
        
            // Hide after 3 seconds (adjust timing as needed)
            setTimeout(() => {
              setIsOpen(false);
            }, 3000);
        
          }, 300);
      }
    })
  }

      return (
        <DefaultContainer>
          <Toast isOpen={isOpen} message={msg} status={status} sx={{width:"480px"}} />
          <Box p={2}>
            <DefaultHeader
                            title={"Reservasi anda"}
                            url={`/?partnerID=${ls.get("sfPartner").id}`}
                            // trailing={
                            //   <ReceiptLongOutlinedIcon
                            //     onClick={(e) => {
                            //       toHistory();
                            //     }}
                            //   />
                            // }
                          />
            <Tabs fullWidth value={tab} onChange={(_, newValue) => setTab(newValue)}>
              <Tab label="Reservasi yang sedang berjalan" />
              <Tab label="Riwayat reservasi" />
            </Tabs>
            <Box mt={2}>
              {tab===1 ?
                history.length>0 ?
                  history.map((item, index) => (
                    <Card key={index} sx={{ mb: 1, p: 1 }} onClick={()=> {setResevationDetails(item); navigate("/history-detail?id=" + item.id)}}>
                      <CardContent>
                        <Typography fontWeight="bold">{item.name}</Typography>
                        <Typography sx={{float:"right"}}>{item.persons} Orang</Typography>
                        <Typography variant="body2" color="textSecondary">{item.reservation_time}</Typography>
                        {item.status==="Finished" ? 
                          <Typography fontWeight="bold" style={{color:"green"}}>
                            Selesai
                          </Typography>
                        :item.status==="Canceled_By_User" ?
                        <Typography fontWeight="bold" style={{color:"red"}}>Dibatalkan Customer</Typography>
                      :item.status==="Canceled_By_Partner" ?
                      <Typography fontWeight="bold" style={{color:"red"}}>Dibatalkan Merchant</Typography>
                      :<Typography fontWeight="bold" style={{color:"red"}}>Customer Tidak Datang</Typography>
                      }
                        <Typography align="right" fontWeight="bold">{item.price}</Typography>
                      </CardContent>
                    </Card>
                  )) 
                  :
                  <Card key={1} sx={{ mb: 1, p: 1 }}>
                      <CardContent sx={{alignItems:"center", justifyContent:"center", justifyItems:"center"}}>
                        <Typography fontWeight="bold" textAlign="center">Belum Ada Reservasi</Typography>
                        <Button  sx={{fontStyle:"none"}} onClick={()=> ls.get('sfPartner').is_special_reservation==="1" ? 
                                        navigate(`/reservation?partnerID=${ls.get('sfPartner').id}`):
                                        navigate(`/reservation-non-special?partnerID=${ls.get('sfPartner').id}`)
                        }>Buat reservasi sekarang</Button>
                      </CardContent>
                  </Card>
            : 
              ongoing.length>0?
                ongoing.map((item, index) => (
                  <Card key={index} sx={{ mb: 1, p: 1 }} onClick={()=> {setResevationDetails(item); navigate("/history-detail?id=" + item.id)}}>
                    <CardContent>
                      <Typography fontWeight="bold">{item.name}</Typography>
                      <Typography sx={{float:"right"}}>{item.persons} Orang</Typography>
                      <Typography variant="body2" color="textSecondary">{item.reservation_time}</Typography>
                      {item.status==="Waiting_For_Approval" ? 
                        <Typography fontWeight="bold" color="#f1e560">
                          Menunggu Konfirmasi
                        </Typography>
                      : item.status==="Approved" ? 
                        <Typography fontWeight="bold" color="green">Disetujui</Typography>
                      : item.status==="Paid" ?
                      <Typography fontWeight="bold" color="green">Dibayar</Typography>
                      :<Typography fontWeight="bold" color="#f1e560">Pending</Typography>
                    }
                      <Typography align="right" fontWeight="bold">{item.price}</Typography>
                    </CardContent>
                  </Card>
                ))
                :
                <Card key={1} sx={{ mb: 1, p: 1 }}>
                      <CardContent sx={{alignItems:"center", justifyContent:"center", justifyItems:"center"}}>
                        <Typography fontWeight="bold" textAlign="center">Belum Ada Reservasi</Typography>
                        <Button sx={{fontStyle:"none"}} onClick={()=> ls.get('sfPartner').is_special_reservation==="1" ? 
                                        navigate(`/reservation?partnerID=${ls.get('sfPartner').id}`):
                                        navigate(`/reservation-non-special?partnerID=${ls.get('sfPartner').id}`)
                        }>Buat reservasi sekarang</Button>
                      </CardContent>
                </Card>
              }
            </Box>
          </Box>
          {/* MODAL DETAILS */}
          <Modal open={reservationModal}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                maxHeight: "80vh", // Limit height to 80% of viewport height
                bgcolor: "#FFFFFF",
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                overflow: "auto", // Enables scrolling if content overflows
                scrollbarWidth:"none"
              }}
            >
              
              <Box sx={{bgcolor:"white", mx:3}} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" fontWeight="bold">
                  Detail Reservasi
                </Typography>
                <IconButton onClick={()=>setReservationModal(!reservationModal)}>
                  <CloseIcon />
                </IconButton>
              </Box>

              
              <Typography variant="h6" mt={2} mx={3} fontWeight="bold">
                {ls.get("sfPartner").name}
              </Typography>
              <Typography variant="body2" mx={3} color="text.secondary">
                {ls.get("sfPartner").address}
              </Typography>

              <Divider sx={{ my: 2 }} />

              
              <Typography fontWeight="bold" mx={3}>Ringkasan Reservasi</Typography>
              <Typography mx={3}>{` <>`} ID Reservasi : {reservationDetails.id}</Typography>
              <Typography mx={3}>👤 {reservationDetails.persons} Orang</Typography>
              <Typography mx={3}>📅 {`${reservationDetails.reservation_time}`}</Typography>
              <Typography mx={3}>📃 {`${reservationDetails.status}`}</Typography>
              <Typography mx={3}>🍽️ {`${reservationDetails.tableName}`}</Typography>
              <Typography mx={3}>Minimum Spend: {reservationDetails?.minimum_transaction}</Typography>
              <Typography mx={3}>Booking Fee: {reservationDetails?.booking_price}</Typography>
              <Divider sx={{ my: 2 }} />

              
              <Typography mx={3} fontWeight="bold">Detail Pemesan</Typography>
              <Typography mx={3}>👤 Nama : {reservationDetails.name}</Typography> 
              <Typography mx={3}>📞 No. Telpon : {reservationDetails.phone}</Typography>
              <Typography mx={3}>📧 Email : {reservationDetails.email}</Typography>
              <Divider sx={{ my: 2 }} />

              <Typography mx={3} fontWeight="bold">Catatan Tambahan</Typography>
              {reservationDetails.description==="" ?<Typography mx={3}>-</Typography>:<Typography mx={3}>{reservationDetails.description}</Typography>}
              {tab===0 ?
              <Grid  sx={{display:"flex", alignItems:"center", justifyContent:"center", alignContent:"center"}}>
                {console.log(reservationDetails)}
                <Button color="red" onClick={()=> setIsDialogOpen(!isDialogOpen)} sx={{display: (reservationDetails.status==="Pending" || reservationDetails.status==="Waiting_For_Approval" || reservationDetails.status==="Approved")? "block":"none"}}>Batalkan Reservasi</Button>
                {isDialogOpen &&
                  <Dialog
                    
                    open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                        <DialogTitle>Informasi</DialogTitle>
                        <DialogContent>
                            <Typography>Apakah anda yakin ingin membatalkan reservasi?</Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setIsDialogOpen(false)} color="primary">
                                Tutup
                            </Button>
                            <Button onClick={() => cancelReservationF(reservationDetails.id)} color="secondary">
                                Batalkan Reservasi
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
              </Grid>
              :
              <></>}
            </Box>
          </Modal>
        </DefaultContainer>
        
    )
}
